import { Button, Modal, Table } from 'react-bootstrap';
import { MatchViewModel } from '../../backend/entryPoints/mapper/mapToMatchViewModel';
import { useEffect, useState } from 'react';
import { checkMatchWinCondition } from '../../logic/game/game';

function MatchEndedModal(props: { visible: boolean; handleClose: () => void; match: MatchViewModel | undefined }) {
    const [winner, setWinner] = useState<number>(-1);
    const [numberOfGames, setNumberOfGames] = useState<number>(0);
    const [homeGames, setHomeGames] = useState<number[]>([]);
    const [guestGames, setGuestGames] = useState<number[]>([]);

    useEffect(() => {
        if (props.match === undefined) {
            return;
        }
        const { standing } = checkMatchWinCondition(
            props.match.games.map((g) => ({ homePoints: g.home_points, guestPoints: g.guest_points }))
        );
        setWinner(standing[0] === 2 ? 0 : standing[1] === 2 ? 1 : -1);
        setNumberOfGames(standing[0] + standing[1]);
        setHomeGames(props.match.games.map((g) => g.home_points));
        setGuestGames(props.match.games.map((g) => g.guest_points));
    }, [props.match]);

    return (
        <Modal show={props.visible} onHide={props.handleClose}>
            <Modal.Header>
                <Modal.Title>Match Ended</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                The match ended. The winner is {winner === 0 ? props.match?.home_team : props.match?.guest_team}.
                <Table>
                    <thead>
                        <tr>
                            <td>Teams</td>
                            {Array.from({ length: numberOfGames }, (_, i) => (
                                <td key={i}>Game {i + 1}</td>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{props.match?.home_team}</td>
                            {homeGames.map((points, index) => (
                                <td key={index}>{points}</td>
                            ))}
                        </tr>
                        <tr>
                            <td>{props.match?.guest_team}</td>
                            {guestGames.map((points, index) => (
                                <td key={index}>{points}</td>
                            ))}
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default MatchEndedModal;
